import { FormHelperText as BaseFormHelperText } from "@chakra-ui/react";

export default BaseFormHelperText;
